import { IEditorV3, isIEditorV3 } from "@azu-business/editor-v3";
import { AitTableData, FigureData } from "aic";
import { AnnotationWhereGroup } from "components/annotations/AnnotationWhereGroup";
import { EditorWithAnnotation } from "components/annotations/interface";
import { v1FigureBody } from "components/tlfpage/V1Figure";
import { eHistoryType, eTlfItemType } from "../enums";
import { isTitlesFootnotesReadDto, TitlesFootnotesReadDto } from "./TitlesFootnotesReadDto";

export interface ITlfItemHistory extends Record<string, unknown> {
  timestamp: string;
  id: number;
  updateType: eHistoryType;
  comment: string;
  userName: string;
}

/**
 * Type guard that asserts whether a value conforms to the ITlfItemHistory shape.
 *
 * @param obj - The object to validate as a TlfItemReadDto
 * @returns boolean
 */
export const isITlfItemHistory = (obj: unknown): obj is ITlfItemHistory => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;

  // Check basic props
  const chkObj = obj as ITlfItemHistory;
  if (!["string", "undefined"].includes(typeof chkObj.timestamp)) return false;
  if (chkObj.id === undefined || typeof chkObj.id !== "number") return false;
  if (chkObj.updateType === undefined || !Object.values(eHistoryType).includes(chkObj.updateType)) {
    return false;
  }
  if (chkObj.comment === undefined || typeof chkObj.comment !== "string") return false;
  if (chkObj.userName === undefined || typeof chkObj.userName !== "string") return false;

  return true;
};

export interface TlfTableReadDto extends TitlesFootnotesReadDto {
  // id: string;
  // azsolId: string;
  // version: number;

  // primaryHierarchyId: string;
  // primaryHierarchyName: string;
  // primaryHierarchyType: eHierarchy;
  // primaryHierarchyLevel: eHierarchyLevel;
  // dNumber: string;

  // tocOrder?: number;
  // tocNumber?: string;
  // tocLabel?: string;
  // tocReleaseStatus?: eReleaseStatus;
  // tocOriginTrafficLight?: MosaicTrafficLightsValue;
  // coreTrafficLight: MosaicTrafficLightsValue;
  // coreTrafficLightSwitch: MosaicTrafficLightSwitch;

  // additionalInformation: string;
  type: eTlfItemType.table;
  // domain: string;
  crystalReference?: string;

  // programName: string;
  // suffix: string;
  // outputName: string;
  // outputType: eTlfOutputType;
  sapReference: string;
  standardsNotes: IEditorV3;
  programmerNotes: IEditorV3;
  // titles: AibBlockLine<IEditorV3>[];
  pageBy: EditorWithAnnotation<AnnotationWhereGroup>;
  body: AitTableData<IEditorV3>;
  // footnotes: AibBlockLine<IEditorV3>[];
  // releaseDate?: Date;
  // decommissionDate?: Date;
  // releaseStatus: eReleaseStatus;

  history: ITlfItemHistory[];
  // relationships: ITlfItemRelationship[];
  // shellMinorVersion: number;
  // comments: CommentReadDto[];
  // isBackupVersion: boolean;
}

export interface TlfListingReadDto extends TitlesFootnotesReadDto {
  type: eTlfItemType.listing;
  body: AitTableData<IEditorV3>;
  crystalReference?: string;
  sapReference: string;
  standardsNotes: IEditorV3;
  programmerNotes: IEditorV3;
  pageBy: EditorWithAnnotation<AnnotationWhereGroup>;
  history: ITlfItemHistory[];
}

export interface TlfV1FigureReadDto extends TitlesFootnotesReadDto {
  type: eTlfItemType.v1figure;
  body: v1FigureBody;
  crystalReference?: string;
  sapReference: string;
  standardsNotes: IEditorV3;
  programmerNotes: IEditorV3;
  pageBy: EditorWithAnnotation<AnnotationWhereGroup>;
  history: ITlfItemHistory[];
}

export interface TlfFigureReadDto extends TitlesFootnotesReadDto {
  type: eTlfItemType.figure;
  body: FigureData;
  crystalReference?: string;
  sapReference: string;
  standardsNotes: IEditorV3;
  programmerNotes: IEditorV3;
  pageBy: EditorWithAnnotation<AnnotationWhereGroup>;
  history: ITlfItemHistory[];
}

export type TlfItemReadDto =
  TlfTableReadDto | TlfListingReadDto | TlfV1FigureReadDto | TlfFigureReadDto;

/**
 * Type guard that asserts whether a value conforms to the TlfItemReadDto shape.
 *
 * @param obj - The object to check
 * @returns true if the object is a TlfItemReadDto, false otherwise
 */
export const isTlfItemReadDto = (obj: unknown): obj is TlfItemReadDto => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;

  // Check lower interface
  if (!isTitlesFootnotesReadDto(obj)) return false;

  // Check basic props
  const chkObj = obj as TlfItemReadDto;
  if (!["undefined", "string"].includes(typeof chkObj.crystalReference)) return false;
  if (typeof chkObj.sapReference !== "string") return false;
  if (!isIEditorV3(chkObj.standardsNotes)) return false;
  if (!isIEditorV3(chkObj.programmerNotes)) return false;
  if (typeof chkObj.pageBy !== "object" || chkObj.pageBy === null) return false;
  if (!isIEditorV3(chkObj.pageBy.content)) return false;
  if (typeof chkObj.body !== "object") return false;

  // Check arrays
  if (!Array.isArray(chkObj.history) || chkObj.history.some((x) => !isITlfItemHistory(x)))
    return false;

  // Everything is good
  return true;
};
